<template>
  <Button :class="`button-form-item_${item.id}`" :buttonStyle="style" :label="options.text" />
</template>

<script>
import FormItemMixin from '@/components/page-editor/widget/form/Mixin.js'
import Button from '@/shared/components/Button'

export default {
  name: 'ButtonFormWidget',
  components: { Button },
  mixins: [FormItemMixin],
  computed: {
    style() {
      return {
        '--button-background-color-hover': this.itemStyle.backgroundColorHover,
        '--button-text-color-hover': this.itemStyle.text.colorHover,
        fontSize: `${this.itemStyle.text.size}px`,
        color: this.itemStyle.text.color,
        background: this.itemStyle.backgroundColor,
        borderColor: this.itemStyle.border.color,
        borderWidth: `${this.itemStyle.border.width}px`,
        borderRadius: `${this.itemStyle.border.radius}px`,
        borderStyle: this.itemStyle.border.style,
        paddingTop: `${this.itemStyle.padding.top}px`,
        paddingRight: `${this.itemStyle.padding.right}px`,
        paddingBottom: `${this.itemStyle.padding.bottom}px`,
        paddingLeft: `${this.itemStyle.padding.left}px`,
        width: '100%',
        height: 'auto',
        margin: '0',
        'justify-content': 'center',
        fontStyle: `${this.itemStyle.text.fontStyle}`,
        fontWeight: `${this.itemStyle.text.weight}`,
        textDecoration: `${this.itemStyle.text.decoration}`,
      }
    },
  },
}
</script>

<style lang="scss">
[class^='button-form-item_'] {
  width: 100%;
  text-align: center;
  cursor: pointer;

  &:hover {
    transition: all 0.2s;
    background: var(--button-background-color-hover) !important;
    color: var(--button-text-color-hover) !important;
  }
}
</style>
